import { render, staticRenderFns } from "./infoGroup.vue?vue&type=template&id=41947526&"
import script from "./infoGroup.vue?vue&type=script&lang=js&"
export * from "./infoGroup.vue?vue&type=script&lang=js&"
import style0 from "./infoGroup.vue?vue&type=style&index=0&id=41947526&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports